import React, { useCallback, useContext, useState } from 'react'
import { Modal, Button, Form, Col, Row } from '@themesberg/react-bootstrap'
import { Context } from '..'
import { upload } from '../controller';

const _Popup = () => {

  const { state, dispatch } = useContext(Context);

  const [image, setImage] = useState(undefined);
  const [image2, setImage2] = useState(undefined);

  const handleClose = useCallback(() => {
    dispatch({
      type: 'CLOSE_EXPORT_POPUP',
      payload: {
        confirmed: false,
      },
    })
  }, [])

  const handleConfirm = useCallback(() => {
    if (image) {
      dispatch({
        type: 'CLOSE_EXPORT_POPUP',
        payload: {
          confirmed: true,
          image: image,
          image2: image2,
        },
      })
      setImage(undefined)
      setImage2(undefined)
    } else {
      alert('Hãy up file vé')
    }
  }, [image, image2])

  const uploadFunc = useCallback(async (file) => {

    const response = await upload(state.exportPopup.id + '_1', 'ticket', file)
    setImage(response)
  }, [
    state.exportPopup.id
  ])

  const upload2Func = useCallback(async (file) => {

    const response = await upload(state.exportPopup.id + '_2', 'ticket', file)
    setImage2(response)
  }, [
    state.exportPopup.id
  ])

  const onImageChange = (evt) => {
    if (evt.target.files[0]) {
      uploadFunc(evt.target.files[0])
    }
  }

  const onImage2Change = (evt) => {
    if (evt.target.files[0]) {
      upload2Func(evt.target.files[0])
    }
  }

  return (
    <Modal as={Modal.Dialog} centered show={state.exportPopup.show} onHide={(handleClose)}>
      <Modal.Header>
        <Modal.Title className="h6">Upload vé</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="firstName">
                <Form.Label>Vé 1</Form.Label>
                <Form.Control required type="file" onChange={onImageChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="firstName">
                <Form.Label>Vé 2</Form.Label>
                <Form.Control required type="file" onChange={onImage2Change} />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {image ? 'Xong' : ''}
        <Button variant="secondary" className="ms-auto" onClick={handleConfirm}>
          Xác nhận
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(_Popup)